import script from "./CursorPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./CursorPagination.vue?vue&type=script&lang=ts&setup=true"

import "./CursorPagination.vue?vue&type=style&index=0&id=416da123&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416da123"]])

export default __exports__